import { useState } from 'react';
import Layout from '../../components/feature/Layout';

const tabs = [
  { id: 'categories', label: 'Kategoriler', icon: 'ri-price-tag-3-line' },
  { id: 'sources', label: 'Kaynak Tanımları', icon: 'ri-signal-tower-line' },
  { id: 'whatsapp', label: 'WhatsApp Entegrasyonu', icon: 'ri-whatsapp-line' },
  { id: 'api', label: 'API & Webhook', icon: 'ri-code-box-line' },
  { id: 'preferences', label: 'Sistem Tercihleri', icon: 'ri-settings-4-line' },
];

const initialCategories = ['Botoks & Dolgu', 'Lazer Epilasyon', 'Cilt Bakımı', 'Saç Bakımı', 'Kirpik & Kaş', 'Masaj & SPA', 'Diş Beyazlatma'];
const initialSources = [
  { id: 1, name: 'Google Ads', identifier: 'google', icon: 'ri-google-line', color: '#D4AF37', active: true },
  { id: 2, name: 'Instagram', identifier: 'instagram', icon: 'ri-instagram-line', color: '#E4405F', active: true },
  { id: 3, name: 'Facebook', identifier: 'facebook', icon: 'ri-facebook-circle-line', color: '#1877F2', active: true },
  { id: 4, name: 'TikTok', identifier: 'tiktok', icon: 'ri-tiktok-line', color: '#010101', active: true },
  { id: 5, name: 'Organik', identifier: 'organic', icon: 'ri-search-line', color: '#7CB342', active: true },
  { id: 6, name: 'YouTube', identifier: 'youtube', icon: 'ri-youtube-line', color: '#FF0000', active: false },
];

const webhookLogs = [
  { id: 1, event: 'lead.created', status: 'success', time: '17 Mar 2026 18:35:03', payload: '{"lead_id": 892, "name": "Ayşe Kaya"}', statusCode: 200 },
  { id: 2, event: 'form.submit', status: 'success', time: '17 Mar 2026 18:12:44', payload: '{"form_id": "frm-002", "campaign": "Hydra Facial"}', statusCode: 200 },
  { id: 3, event: 'lead.created', status: 'error', time: '17 Mar 2026 17:55:11', payload: '{"lead_id": 891, "name": "Zeynep Aydın"}', statusCode: 503 },
  { id: 4, event: 'whatsapp.click', status: 'success', time: '17 Mar 2026 17:42:08', payload: '{"campaign": "Lazer Epilasyon", "visitor": "V-7B3D9E"}', statusCode: 200 },
];

function CategoriesTab() {
  const [categories, setCategories] = useState(initialCategories);
  const [newCat, setNewCat] = useState('');
  const [editingIdx, setEditingIdx] = useState<number | null>(null);
  const [editVal, setEditVal] = useState('');

  const addCategory = () => {
    if (!newCat.trim()) return;
    setCategories([...categories, newCat.trim()]);
    setNewCat('');
  };

  const deleteCategory = (idx: number) => setCategories(categories.filter((_, i) => i !== idx));

  const startEdit = (idx: number) => { setEditingIdx(idx); setEditVal(categories[idx]); };
  const saveEdit = () => {
    if (editingIdx === null || !editVal.trim()) return;
    const updated = [...categories];
    updated[editingIdx] = editVal.trim();
    setCategories(updated);
    setEditingIdx(null);
  };

  return (
    <div className="space-y-5">
      <div className="flex gap-3">
        <input value={newCat} onChange={e => setNewCat(e.target.value)} onKeyDown={e => e.key === 'Enter' && addCategory()} placeholder="Yeni kategori adı..." className="flex-1 h-[42px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 placeholder-charcoal-300 focus:outline-none focus:border-champagne-400" />
        <button onClick={addCategory} className="h-[42px] px-5 bg-champagne-500 text-white rounded-xl text-[13px] font-medium hover:bg-champagne-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2">
          <div className="w-4 h-4 flex items-center justify-center"><i className="ri-add-line text-[15px]" /></div>
          Ekle
        </button>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {categories.map((cat, idx) => (
          <div key={idx} className="flex items-center gap-3 bg-[#FAF8F4] rounded-xl px-4 py-3 group">
            <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-champagne-100">
              <i className="ri-price-tag-3-line text-champagne-600 text-[13px]" />
            </div>
            {editingIdx === idx ? (
              <input value={editVal} onChange={e => setEditVal(e.target.value)} onKeyDown={e => e.key === 'Enter' && saveEdit()} className="flex-1 bg-white border border-champagne-400 rounded-lg px-2 py-1 text-[13px] focus:outline-none" autoFocus />
            ) : (
              <span className="flex-1 text-[13px] font-medium text-charcoal-600">{cat}</span>
            )}
            <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              {editingIdx === idx ? (
                <button onClick={saveEdit} className="w-7 h-7 flex items-center justify-center rounded-lg bg-green-50 hover:bg-green-100 cursor-pointer">
                  <i className="ri-check-line text-green-600 text-[13px]" />
                </button>
              ) : (
                <button onClick={() => startEdit(idx)} className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-champagne-100 cursor-pointer">
                  <i className="ri-edit-line text-charcoal-400 text-[13px]" />
                </button>
              )}
              <button onClick={() => deleteCategory(idx)} className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-red-50 cursor-pointer">
                <i className="ri-delete-bin-line text-red-400 text-[13px]" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function SourcesTab() {
  const [sources, setSources] = useState(initialSources);
  const toggleSource = (id: number) => setSources(sources.map(s => s.id === id ? { ...s, active: !s.active } : s));

  return (
    <div className="space-y-3">
      {sources.map(src => (
        <div key={src.id} className="flex items-center gap-4 bg-[#FAF8F4] rounded-xl px-5 py-4">
          <div className="w-9 h-9 flex items-center justify-center rounded-xl" style={{ backgroundColor: `${src.color}15` }}>
            <i className={`${src.icon} text-[16px]`} style={{ color: src.color }} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[13px] font-semibold text-charcoal-600">{src.name}</p>
            <p className="text-[11px] text-charcoal-300 font-mono">{src.identifier}</p>
          </div>
          <button onClick={() => toggleSource(src.id)} className={`w-11 h-6 rounded-full transition-colors cursor-pointer relative ${src.active ? 'bg-champagne-500' : 'bg-charcoal-200'}`}>
            <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-sm transition-all ${src.active ? 'left-[22px]' : 'left-0.5'}`} />
          </button>
        </div>
      ))}
    </div>
  );
}

function WhatsAppTab() {
  const [phoneNumber, setPhoneNumber] = useState('+90 532 000 00 00');
  const [defaultMessage, setDefaultMessage] = useState('Merhaba! {kampanya_adi} hakkında bilgi almak istiyorum.');
  const [trackingEnabled, setTrackingEnabled] = useState(true);

  return (
    <div className="space-y-5 max-w-xl">
      <div>
        <label className="block text-[12px] font-semibold text-charcoal-400 mb-2 uppercase tracking-wide">WhatsApp Numarası</label>
        <input value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} className="w-full h-[42px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400" />
      </div>
      <div>
        <label className="block text-[12px] font-semibold text-charcoal-400 mb-2 uppercase tracking-wide">Varsayılan Mesaj Şablonu</label>
        <textarea value={defaultMessage} onChange={e => setDefaultMessage(e.target.value)} rows={3} maxLength={500} className="w-full px-4 py-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 resize-none" />
        <p className="text-[11px] text-charcoal-300 mt-1">Değişkenler: {'{kampanya_adi}'}, {'{salon_adi}'}, {'{iskontos}'}</p>
      </div>
      <div className="flex items-center justify-between p-4 bg-[#FAF8F4] rounded-xl">
        <div>
          <p className="text-[13px] font-semibold text-charcoal-600">Tıklama Takibi</p>
          <p className="text-[11px] text-charcoal-300">WhatsApp tıklamalarını event olarak kaydet</p>
        </div>
        <button onClick={() => setTrackingEnabled(!trackingEnabled)} className={`w-11 h-6 rounded-full transition-colors cursor-pointer relative ${trackingEnabled ? 'bg-champagne-500' : 'bg-charcoal-200'}`}>
          <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-sm transition-all ${trackingEnabled ? 'left-[22px]' : 'left-0.5'}`} />
        </button>
      </div>
      <button className="h-[42px] px-6 bg-champagne-500 text-white rounded-xl text-[13px] font-medium hover:bg-champagne-600 transition-colors cursor-pointer whitespace-nowrap">Ayarları Kaydet</button>
    </div>
  );
}

function ApiTab() {
  const [showKey, setShowKey] = useState(false);
  const apiKey = 'sk-salon-live-xK9mP2qR8nL4wT6vZ3cJ1hY5eB7aF0dG';

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-[12px] font-semibold text-charcoal-400 mb-2 uppercase tracking-wide">API Anahtarı</label>
        <div className="flex gap-2">
          <div className="flex-1 h-[42px] px-4 bg-[#FAF8F4] border border-border rounded-xl flex items-center font-mono text-[12px] text-charcoal-500">
            {showKey ? apiKey : '•'.repeat(40)}
          </div>
          <button onClick={() => setShowKey(!showKey)} className="w-[42px] h-[42px] flex items-center justify-center bg-[#FAF8F4] border border-border rounded-xl hover:border-champagne-400 transition-colors cursor-pointer">
            <i className={`${showKey ? 'ri-eye-off-line' : 'ri-eye-line'} text-charcoal-400 text-[16px]`} />
          </button>
          <button className="h-[42px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[12px] text-charcoal-400 hover:border-champagne-400 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-file-copy-line text-[13px]" /></div>
            Kopyala
          </button>
        </div>
      </div>

      <div>
        <label className="block text-[12px] font-semibold text-charcoal-400 mb-2 uppercase tracking-wide">Webhook URL</label>
        <input defaultValue="https://your-server.com/webhook/salon-events" className="w-full h-[42px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400" />
      </div>

      <div>
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-[13px] font-semibold text-charcoal-600">Son Webhook Logları</h4>
          <button className="text-[12px] text-champagne-600 hover:text-champagne-700 cursor-pointer">Tümünü Temizle</button>
        </div>
        <div className="border border-border rounded-xl overflow-hidden">
          {webhookLogs.map((log, idx) => (
            <div key={log.id} className={`flex items-center gap-4 px-4 py-3 ${idx < webhookLogs.length - 1 ? 'border-b border-border' : ''} ${idx % 2 === 0 ? '' : 'bg-[#FDFCFA]'}`}>
              <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[10px] font-bold whitespace-nowrap ${log.status === 'success' ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-500'}`}>
                {log.status === 'success' ? '200 OK' : `${log.statusCode} ERR`}
              </span>
              <span className="text-[12px] font-mono text-champagne-600 flex-shrink-0">{log.event}</span>
              <span className="text-[12px] text-charcoal-400 flex-1 min-w-0 truncate">{log.payload}</span>
              <span className="text-[11px] text-charcoal-300 font-mono flex-shrink-0 whitespace-nowrap">{log.time.split(' ').slice(-1)[0]}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function PreferencesTab() {
  const [settings, setSettings] = useState({
    timezone: 'Europe/Istanbul',
    language: 'tr',
    currency: 'TRY',
    leadNotifications: true,
    dailyReport: true,
    sessionTimeout: '30',
    dataRetention: '12',
  });

  const update = (key: string, val: string | boolean) => setSettings(prev => ({ ...prev, [key]: val }));

  return (
    <div className="space-y-5 max-w-xl">
      {[
        { key: 'timezone', label: 'Zaman Dilimi', type: 'select', options: ['Europe/Istanbul', 'UTC', 'Europe/London'] },
        { key: 'language', label: 'Dil', type: 'select', options: [{ v: 'tr', l: 'Türkçe' }, { v: 'en', l: 'English' }] as any },
        { key: 'currency', label: 'Para Birimi', type: 'select', options: ['TRY', 'USD', 'EUR'] },
        { key: 'sessionTimeout', label: 'Oturum Zaman Aşımı (dakika)', type: 'number' },
        { key: 'dataRetention', label: 'Veri Saklama Süresi (ay)', type: 'number' },
      ].map(field => (
        <div key={field.key}>
          <label className="block text-[12px] font-semibold text-charcoal-400 mb-2 uppercase tracking-wide">{field.label}</label>
          {field.type === 'select' ? (
            <select value={(settings as any)[field.key]} onChange={e => update(field.key, e.target.value)} className="w-full h-[42px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
              {(field.options as any[]).map(o => typeof o === 'string' ? <option key={o} value={o}>{o}</option> : <option key={o.v} value={o.v}>{o.l}</option>)}
            </select>
          ) : (
            <input type="number" value={(settings as any)[field.key]} onChange={e => update(field.key, e.target.value)} className="w-full h-[42px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400" />
          )}
        </div>
      ))}

      {[
        { key: 'leadNotifications', label: 'Yeni Lead Bildirimi', desc: 'Yeni lead oluştuğunda anlık bildirim al' },
        { key: 'dailyReport', label: 'Günlük Rapor E-Postası', desc: 'Her gün sabah 08:00\'de özet gönder' },
      ].map(toggle => (
        <div key={toggle.key} className="flex items-center justify-between p-4 bg-[#FAF8F4] rounded-xl">
          <div>
            <p className="text-[13px] font-semibold text-charcoal-600">{toggle.label}</p>
            <p className="text-[11px] text-charcoal-300">{toggle.desc}</p>
          </div>
          <button onClick={() => update(toggle.key, !(settings as any)[toggle.key])} className={`w-11 h-6 rounded-full transition-colors cursor-pointer relative ${(settings as any)[toggle.key] ? 'bg-champagne-500' : 'bg-charcoal-200'}`}>
            <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-sm transition-all ${(settings as any)[toggle.key] ? 'left-[22px]' : 'left-0.5'}`} />
          </button>
        </div>
      ))}

      <button className="h-[42px] px-6 bg-champagne-500 text-white rounded-xl text-[13px] font-medium hover:bg-champagne-600 transition-colors cursor-pointer whitespace-nowrap">Tercihleri Kaydet</button>
    </div>
  );
}

export default function Settings() {
  const [activeTab, setActiveTab] = useState('categories');

  const renderContent = () => {
    switch (activeTab) {
      case 'categories': return <CategoriesTab />;
      case 'sources': return <SourcesTab />;
      case 'whatsapp': return <WhatsAppTab />;
      case 'api': return <ApiTab />;
      case 'preferences': return <PreferencesTab />;
      default: return null;
    }
  };

  return (
    <Layout>
      <div className="flex gap-5">
        {/* Sidebar Tabs */}
        <div className="w-[220px] flex-shrink-0">
          <div className="bg-white rounded-2xl shadow-card p-3 space-y-1">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl text-[13px] font-medium transition-all cursor-pointer whitespace-nowrap
                  ${activeTab === tab.id ? 'bg-champagne-50 text-champagne-700' : 'text-charcoal-400 hover:bg-[#FAF8F4] hover:text-charcoal-600'}
                `}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${tab.icon} text-[15px] ${activeTab === tab.id ? 'text-champagne-600' : 'text-charcoal-400'}`} />
                </div>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="bg-white rounded-2xl shadow-card p-6">
            <div className="mb-6 pb-4 border-b border-border">
              <h2 className="text-[17px] font-bold text-charcoal-600">{tabs.find(t => t.id === activeTab)?.label}</h2>
              <p className="text-[12px] text-charcoal-300 mt-0.5">Sistem ayarlarını yapılandırın</p>
            </div>
            {renderContent()}
          </div>
        </div>
      </div>
    </Layout>
  );
}
